import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@store/hooks';
import { selectSelectedFloorId } from '@store/selectors/monitor.selectors';
import { useSetSelectedFloor } from '../hooks';
import type { IReplayController } from '../replay/useReplayController';
import { BuildingViewSvg } from './BuildingViewSvg';
import styles from './mainView.module.css';

/** The building card's pieces, laid out by the page's card and by fullscreen.
 *  `zoom`: fullscreen's zoom step, which the building's chips grow with. */
export function useBuildingCard(replay: IReplayController | undefined, zoom = 1) {
  const { t } = useTranslation();
  const setSelectedFloor = useSetSelectedFloor();
  const selectedFloorId = useAppSelector(selectSelectedFloorId);
  // The mode, not the data: an open bar at the live edge is still replay mode.
  const replayMode = replay?.open ?? false;
  return {
    cardClassName: replayMode ? `${styles.card} ${styles.replaying}` : styles.card,
    buildingClassName: replay?.loading ? `${styles.building} ${styles.buildingLoading}` : styles.building,
    cardLabel: t('monitor.buildingCard.title'),
    building: (
      <BuildingViewSvg
        selectedFloorId={selectedFloorId}
        onSelect={setSelectedFloor}
        showLiveEvents={replay !== undefined && !replayMode}
        zoom={zoom}
      />
    ),
    failed: replay?.failed && <p role="alert" className={styles.replayFailed}>{t('monitor.replay.loadFailed')}</p>,
  };
}
